import { motion } from "framer-motion";

// Simple scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal. `lines` is an array of strings/nodes.
export const MaskLines = ({ lines, className = "", lineClassName = "", start = 0.15, stagger = 0.12 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden">
        <motion.div
          className={lineClassName}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 1,
            delay: start + i * stagger,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

// Volt pill button with sweeping fill on hover
export const VoltButton = ({ children, className = "", filled = false, ...rest }) => (
  <button
    className={
      "group relative overflow-hidden rounded-full px-7 py-3 text-xs uppercase tracking-[0.2em] font-medium transition-colors duration-300 " +
      (filled
        ? "bg-brand-volt text-brand-bg hover:bg-brand-volt-hover "
        : "border border-brand-line text-brand-bone hover:text-brand-bg ") +
      className
    }
    {...rest}
  >
    {!filled && (
      <span className="absolute inset-0 -z-0 translate-y-full bg-brand-volt transition-transform duration-300 ease-out group-hover:translate-y-0" />
    )}
    <span className="relative z-10">{children}</span>
  </button>
);
